// otp/mfaLogin

import { QueryKeys } from "@/constants";
import { useNotificationError } from "@/context/error-provider";
import { ErrorNotificationType } from "@/pages/components/error-notification";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

export type IMfaLoginPayload = {
  divisionId: string;
  enteredOTP: string;
  groupId: string;
  loginGroupId: string;
  username: string;
  signature?: string;
};

export type IMfaLoginResponse = {
  is_mfa_enabled: boolean;
  roles: string[];
  token_type: string;
  message: string;
  sid: string;
  access_token: string;
  refresh_token: string;
  phone: string;
  success: boolean;
  expires_in: number;
  email: string;
  username: string;
  status: string;
};

export type IMfaLoginResendOtpPayload = {
  divisionId: string;
  groupId: string;
  loginGroupId: string;
  username: string;
  signature?: string;
};

export type IMfaLoginResendOtpResponse = {
  waitingTime: number;
  message: string;
  success: boolean;
  status: string;
};

const mfaLoginOtp = async (info: IMfaLoginPayload) => {
  const payloadData = {
    enteredOTP: info.enteredOTP,
    groupId: info.groupId,
    loginGroupId: info.loginGroupId,
    username: info.username,
  };

  const config = {
    method: "POST",
    url: "otp/mfaLogin",
    headers: {
      // Authorization: `Bearer ${info.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
      Signature: info.signature,
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => response.data);
};

export const useMMfaLoginOtp = () => {
  const { addError } = useNotificationError();
  return useMutation({
    mutationKey: [QueryKeys.LOGIN_MFA],

    mutationFn: (mfaLoginOtpPayload: IMfaLoginPayload) =>
      mfaLoginOtp(mfaLoginOtpPayload),

    onSuccess: (response: IMfaLoginResponse) => {
      if (!response.success) {
        addError({
          message: response.message,
          type: ErrorNotificationType.ERROR,
        });
      } else {
        addError({
          message: "Logged in successfully",
          type: ErrorNotificationType.INFO,
        });
      }
    },

    onError: (error: AxiosError) => {
      addError({
        message: error.message,
        type: ErrorNotificationType.ERROR,
      });
    },
  });
};

const mfaLoginResendOtp = async (info: IMfaLoginResendOtpPayload) => {
  const payloadData = {
    groupId: info.groupId,
    loginGroupId: info.loginGroupId,
    username: info.username,
  };

  const config = {
    method: "POST",
    url: "otp/mfaLoginReq",
    headers: {
      "Content-Type": "application/json",
      "Accept-Version": "1.0",
      Signature: info.signature,
      Groupid: info.groupId,
    },
    data: payloadData,
  };

  return httpClient.request(config).then((response) => response.data);
};

export const useMMfaLoginResendOtp = () => {
  const { addError } = useNotificationError();
  return useMutation({
    mutationKey: [QueryKeys.LOGIN_MFA_RESEND_OTP],

    mutationFn: (mfaLoginResendOtpPayload: IMfaLoginResendOtpPayload) =>
      mfaLoginResendOtp(mfaLoginResendOtpPayload),

    onSuccess: (response: IMfaLoginResendOtpResponse) => {
      if (!response.success) {
        addError({
          message: response.message,
          type: ErrorNotificationType.ERROR,
        });
      } else {
        addError({
          message: response.message,
          type: ErrorNotificationType.INFO,
        });
      }
    },
  });
};
